import * as React from "react";
import { useCallback, useState } from "react";
import Box from "../../../parts/Box";
import { Button } from "reactstrap";
import { InputText } from "primereact/inputtext";
import LoadExample from "./LoadExample";
import * as Messages from "../../../Messages";
import IsoformTable from "./IsoformTable";
import KnownTargetImagePrefetch from "./KnownTargetImagePrefetch";
import KnownTargetTable from "./KnownTargetTable";
import MutationBoxComponent from "../components/mutation/MutationBoxComponent";
import { useInputContext } from "../context/input-context";

function KnownTargetComponent() {

  // Context:
  
  const {
    targets,
    failed,
    rows,
    rowSelected, setRowSelected,
    targetSelected, setTargetSelected,
  } = useInputContext();

  const loading = rows.length === 0 && !failed;
  
  const reset = useCallback(() => setRowSelected(null), [setRowSelected]);
  
  // Global filter:
  const [globalFilter, setGlobalFilter] = useState('');
  const clearGlobalFilter = useCallback(() => setGlobalFilter(''), []);
  const onGlobalFilterInput = useCallback(e => setGlobalFilter(e.target.value), []);

  return <>
    <KnownTargetImagePrefetch targets={targets} />
    <Box title="Select target protein">
      <div className="ll-known-target-header">
        <div>
          <LoadExample clearGlobalFilter={clearGlobalFilter} />
        </div>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            value={globalFilter}
            onInput={onGlobalFilterInput}
            placeholder="Search"
            disabled={rowSelected !== null || !rows || rows.length === 0}
          />
        </span>
      </div>
      <KnownTargetTable
        dataRows={rows}
        selected={rowSelected}
        loading={loading}
        failed={failed}
        selectRow={setRowSelected}
        globalFilter={globalFilter}
        clearGlobalFilter={clearGlobalFilter}
      />
      {rowSelected ? (
        <div style={{ textAlign: 'right', marginTop: '1rem' }}>
          <Button onClick={reset}>Reset protein selection</Button>
        </div>
      ) : (
        <div style={{ marginTop: '1rem' }} className="ll-target-protein-request">
          {Messages.PROTEIN_REQUEST()}
        </div>
      )}
      {/* TODO other input methods are not implemented yet */}
      {/* <p className="ll-input-method-link-nav">
                <RouterNavLink to={ll_url('/structure')}>Use different target protein</RouterNavLink>
                <HelpTooltip>{inputTooltips.useDifferentTargetProteinBtn}</HelpTooltip>
            </p> */}
    </Box>
    {rowSelected && rowSelected.proteins.length > 1 ? (
      <Box title="Select isoform">
        <IsoformTable
          targets={rowSelected.proteins}
          selected={targetSelected}
          selectTarget={setTargetSelected}
        />
      </Box>
    ) : null}
    {targetSelected ? (
      <MutationBoxComponent />
    ) : null}
  </>
}

export default KnownTargetComponent;
